var initialize = function(oneSignal, id, options){

    return oneSignal.init({
        appId: id,
        autoRegister: false,
        welcomeNotification: {
            disable: true
        }
    }).then(function(){
        return Promise.resolve(oneSignal);
    });
}

export default initialize;



//////////////////
// WEBPACK FOOTER
// ./src/one-signal/initialize.js
// module id = 4
// module chunks = 0